import { useEffect, useState } from 'react';

// Visitor's base currency for exchange rates (ticker strip and /prices),
// remembered in this browser. Rates come from the Bank of Canada (CAD for
// 1 unit of each currency); other bases are cross rates computed here:
// in base B, 1 X = rate(X) / rate(B) B. CAD itself is rate 1.
const KEY = 'pme_fx_base';
const EVENT = 'pme:fxbase';

function readBase() {
  try { return localStorage.getItem(KEY) || 'CAD'; } catch { return 'CAD'; }
}

export function useFxBase() {
  const [base, setBaseState] = useState(readBase);
  useEffect(() => {
    const sync = () => setBaseState(readBase());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener('storage', sync); };
  }, []);
  const setBase = (code) => {
    try { localStorage.setItem(KEY, code); } catch { /* private mode: this page only */ }
    setBaseState(code);
    window.dispatchEvent(new Event(EVENT)); // keep the strip and /prices in step
  };
  return [base, setBase];
}

// Bases a visitor can pick: CAD + every currency we have a rate for.
export const baseOptions = (items) => ['CAD', ...items.filter((i) => i.rate > 0).map((i) => i.code)];

// items: [{ code, rate, prevRate, date }] in CAD. Returns the list priced in
// `base` (CAD added as an item when base isn't CAD), with day change.
export function crossRates(items, base) {
  const all = [{ code: 'CAD', rate: 1, prevRate: 1, date: items[0]?.date || null }, ...items.filter((i) => i.rate > 0)];
  const b = all.find((i) => i.code === base) || all[0];
  return all.filter((i) => i.code !== b.code).map((i) => {
    const rate = i.rate / b.rate;
    const prev = i.prevRate && b.prevRate ? i.prevRate / b.prevRate : null;
    const change = prev ? rate - prev : null;
    return { code: i.code, base: b.code, rate, date: i.date, change, changePct: change !== null ? (change / prev) * 100 : null };
  });
}
